<template>
  <div class="home">
    <PhotoWall :imgUrls="coverImgUrls" :autoDisplay="false" coverLetter=":Home"></PhotoWall>
  </div>
</template>

<script>
// @ is an alias to /src
import PhotoWall from "@/components/PhotoWall.vue";

export default {
  name: "home",
  components: {
    PhotoWall
  },
  data() {
    return {
      coverImgUrls: [
        "https://images.unsplash.com/photo-1526880792616-4217886b9dc2?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80"
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  position: relative;
}
.wrapper {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  padding: var(--g-xxl) 0 calc(2 * var(--g-xxl)) 0;
}
.info-card {
  padding: var(--g-xl);
  display: flex;
  flex-flow: column;
  align-items: center;
  text-align: center;
  width: 50%;
  min-width: 300px;
  max-width: 500px;
  i {
    font-size: var(--fs-l);
    margin-bottom: var(--g-l);
  }
}
</style>
